<template>
  <div>
    <TopoComponent></TopoComponent>
    <div class="container vertical-align login escolha mt-4 text-center">
      <div class="row">
        <form class="form-signin">
          <div>
            <h2>
              Os dados de {{ firstName }} estão corretos?
            </h2>
            <p>
              Confirme ou atualize os dados deste dependente. 
            </p>

            <span class="dados"
              >Dt Nascimento: {{ dependente.dataNascimento || 'Não informado'  }}</span
            ><br />
            <span class="dados">Email: {{ dependente.email || 'Não informado'  }}</span
            ><br />
            <span class="dados">Celular: {{ dependente.celular || 'Não informado'  }}</span
            ><br />
            <span class="dados">CPF: {{ dependente.cpf || 'Não informado' }}</span
            ><br />

            <div class="clearfix"></div>
            <div class="mt-4">
              <button
                class="btn btn-lg btn-primary btn-block button success"
                type="button"
                @click="ativarDependente"
              >
                {{ labelBotao }}
              </button>
              <BtnOutlineDanger
                type="button"
                @click="redirectAtualizarDados"
              >
                Atualizar dados
              </BtnOutlineDanger>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import TopoComponent from "@/components/TopoComponent";
import BtnOutlineDanger from "@/components/BtnOutlineDanger";

export default {
  components: { TopoComponent, BtnOutlineDanger },
  name: "ExibirDadosDependente",
  props: ["indiceDependente", "contaPropria"],
  data() {
    return {
      dependente: {},
      firstName: '',
      labelBotao: "Continuar",
      flagPermiteEmail: JSON.parse(sessionStorage.getItem("flagPermiteEmail")),
      flagPermiteSms: JSON.parse(sessionStorage.getItem("flagPermiteSms")),
    };
  },
  mounted: function() {
    if (sessionStorage.getItem("dependentes") != null) {
      const dependentes = JSON.parse(sessionStorage.getItem("dependentes"));
      this.dependente = dependentes[this.indiceDependente];

      if (
        this.dependente.email == null ||
        this.dependente.celular == null ||
        this.dependente.dataNascimento == null
      ) {
        this.redirectAtualizarDados();
      } else if (
        this.contaPropria === "true" &&
        (this.dependente.emailDependenteIgualTitular ||
          this.dependente.cpfDependenteIgualTitular)
      ) {
        this.redirectAtualizarDados();
      } else if (
        this.contaPropria === "true" &&
        !this.dependente.cpf
      ) {
        this.redirectAtualizarDados();
      }
      this.firstName = this.dependente.nome.split(' ')[0]

    }
  },

  computed: {
    clinicaNaoPermiteComunicacao() {
      return !this.flagPermiteEmail && !this.flagPermiteSms;
    },
  },
  methods: {
    ativarDependente() {
      if (this.contaPropria == "true") {
        // 3B - só ativará após cadastro da senha
        if (this.clinicaNaoPermiteComunicacao) {
          this.$router.push(
            `/cadastrar-senha/dependente/${this.indiceDependente}`
          );
        } else {
          this.$router.push(
            `/selecionar-metodo-de-validacao-da-conta/dependente/${
              this.indiceDependente
            }`
          );
        }
      } else {
        this.atualizarEmailDependente(this.dependente)
        let dependentes = JSON.parse(
          sessionStorage.getItem("dependentes")
        );
        dependentes = dependentes.filter((dependente) => {
          return parseInt(dependente.idDependente) !== parseInt(this.dependente.idDependente);
        });
        sessionStorage.setItem(
          "dependentes",
          JSON.stringify(dependentes)
        );
        this.salvarDependenteParaAtivar(this.dependente)
        if (dependentes.length == 0) {
          this.$router.push("/termos-e-condicoes");
        } else {
          this.$router.push("/selecionar-dependente");
        }
      }
    },
    atualizarEmailDependente(dependente) {
      this.$conexaApi
        .put(
            "/integration/ativacao/paciente/" +
            dependente.token +
            "/atualizar-email-dependente",
          {
            dependenteContaPropria: false,
          },
        )
    },
    salvarDependenteParaAtivar(dependente) {
      const dependentesParaAtivar = JSON.parse(sessionStorage.getItem("dependentesParaAtivar")) || [];
      dependentesParaAtivar.push(dependente)
      sessionStorage.setItem("dependentesParaAtivar", JSON.stringify(dependentesParaAtivar));
    },
    redirectAtualizarDados() {
      this.$router.push(`/atualizar-dados-do-dependente/${
        this.indiceDependente
      }/${this.contaPropria}`);
    },
  },
};
</script>

<style scoped>
.imgFalha {
  max-width: 180px;
  text-align: center;
}
.divFalha {
  text-align: center;
}
.imgContato {
  max-width: 50px;
  text-align: center;
}
.imgWhatsapp {
  max-width: 25px;
  text-align: center;
}
.imgEmail {
  max-width: 25px;
  text-align: center;
}
.mensagemFalha {
  color: gray;
  text-align: center;
  font-size: 20px;
}

.dados {
  color: darkgray;
  font-weight: bold;
  margin-top: 5px;
  line-height: 3.7;
}
</style>
